
import { Component, OnInit } from '@angular/core';
import { RouterModule, Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AppServiceService } from '../../app-service.service';
import Swal from 'sweetalert2';

declare var $;

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})

export class LoginComponent implements OnInit {
  public code;
  public loginForm: FormGroup;
  public submitted = false;
  public rememberMe = false;
  public loading = false;
  public recaptcha: any[];
  constructor(public router: Router, public formBuilder: FormBuilder, public appService: AppServiceService) { }

  ngOnInit() {
    this.loginForm = this.formBuilder.group({
      userName: ['', [Validators.required]],
      password: ['', [Validators.required]]
    });

    if (localStorage.getItem('PatientEmailId')) {
      let emailId = this.appService.decryptData(localStorage.getItem('PatientEmailId'));
      emailId = emailId.replace(/['",<>\{\}\[\]\\\/]/gi, '');
      if (emailId) {
        console.log(emailId);
        $('#rememberMe').prop('checked', true);
        this.loginForm = this.formBuilder.group({
          userName: [emailId, [Validators.required]],
          password: ['', [Validators.required]],
         });
      }
    }
  }

  saveLogInInfo() {
    if ($('#rememberMe').is(':checked')) {
      this.rememberMe = true;
      console.log(this.rememberMe);
    } else  {
      this.rememberMe = false;
      console.log(this.rememberMe);
    }
  }
  resolved(captchaResponse: any[]) {
    this.recaptcha = captchaResponse;
  }
  clickeye() {
    const password = document.querySelector('#id_password');
    const type = password.getAttribute('type') === 'password' ? 'text' : 'password';
    password.setAttribute('type', type);
  }
  
   onSubmit(formValues) {
    this.submitted = true;
    if (this.loginForm.invalid) { 
      return;
    }
    if (this.recaptcha === undefined) {
      Swal.fire('', 'Invalid Captcha. Try Again', 'info');
    } else if ((formValues.userName !== '') && (formValues.password !== '')) {
      const postJson = {
        UserName: formValues.userName,
        Password: formValues.password,
        type:'1',

      };

      const url = this.appService.serviceURL + 'ValidateUserLogin';
      this.loading = true;
      this.appService.postData(url, postJson).subscribe(data => {
        if (data.status === 0) {
          this.loading = false;
          $('#error_msg').show();
        }else if(data.status == 3){
          this.loading = false;
          Swal.fire('', 'Patient Sign in application license for '+ data.clinic_name + ' is expired, Please reach out to your Business Admin('+data.Email_id+') to renew the license', 'info');
        }  else {
          if (this.rememberMe) {
            localStorage.setItem('PatientEmailId', this.appService.encryptData(formValues.userName));
          } else {
            if (localStorage.getItem('PatientEmailId')) {
              localStorage.removeItem('PatientEmailId');
            }
          }
          const loginDetails = this.appService.encryptData(data);
          localStorage.removeItem('LogInDetails');
          localStorage.setItem('LogInDetails', loginDetails);
          this.loading = false;
          this.router.navigateByUrl('/Patient/SignIn');
        }
      });
    }
  }
}
